import z from "zod";

export const importConfigsDialogConfigurationParametersSchema = z.object({
    crmProjectName: z.string().min(1, "CRM Project Name is required"),
    crmConfigName: z.string().min(1, "CRM Config Name is required"),
    crmProjectFilePropertyToParameterMap: z.record(z.string(),z.string().optional()).optional(),
    crmConfigFilePropertyToParameterMap: z.record(z.string(),z.string().optional()).optional(),
})

export const editConfigDialogTabSchema = z.object({
    name: z.string(),
    configParameters: z.record(z.string(),z.string().optional()).optional()
})